// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fancySpinner {
  width: var(--spinnerSize);
  height: var(--spinnerSize);
  animation: fancySpinnerAnimation 2s linear infinite;
  margin: auto;
}

.ol-prequal-status {
  margin: 16px auto 0;
  padding: 0 24px;
  color: #000000;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
}

.ol-prequal-status--visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.stroke {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  transform: rotate(-90deg);
}

.stroke>circle {
  fill: none;
  stroke-width: 8px;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke-dasharray: 1, 300;
  transform-origin: center center;
}

@keyframes fancySpinnerAnimation {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes strokeAnimation {
  0% {
    stroke-dasharray: 1, 300;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 120, 300;
    stroke-dashoffset: calc(-1 * (var(--spinnerCircumference)) / 3);
  }

  100% {
    stroke-dasharray: 120, 300;
    stroke-dashoffset: calc(-1 * (var(--spinnerCircumference)));
  }
}
`, "",{"version":3,"sources":["webpack://./src/modal/spinner.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,+DAA+D;EACjE;;EAEA;IACE,0BAA0B;IAC1B,2DAA2D;EAC7D;AACF","sourcesContent":["\n.fancySpinner {\n  width: var(--spinnerSize);\n  height: var(--spinnerSize);\n  animation: fancySpinnerAnimation 2s linear infinite;\n  margin: auto;\n}\n\n.ol-prequal-status {\n  margin: 16px auto 0;\n  padding: 0 24px;\n  color: #000000;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.ol-prequal-status--visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n  border: 0;\n}\n\n.stroke {\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: absolute;\n  transform: rotate(-90deg);\n}\n\n.stroke>circle {\n  fill: none;\n  stroke-width: 8px;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  stroke-dasharray: 1, 300;\n  transform-origin: center center;\n}\n\n@keyframes fancySpinnerAnimation {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes strokeAnimation {\n  0% {\n    stroke-dasharray: 1, 300;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 120, 300;\n    stroke-dashoffset: calc(-1 * (var(--spinnerCircumference)) / 3);\n  }\n\n  100% {\n    stroke-dasharray: 120, 300;\n    stroke-dashoffset: calc(-1 * (var(--spinnerCircumference)));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
